<template>
  <div>
    <b-overlay :show="loading" rounded="sm">
      <template #overlay>
        <OverlayButton clase="overlay-md"> </OverlayButton>
      </template>
      <b-tabs v-model="tabIndex" class="tabs-section-form-salud-event">
        <div class="card-form-section mt-5">
          <hr class="hr-form-salud-event" />
          <b-tab>
            <template #title>
              <div class="d-flex align-items-center">1. Registro</div>
            </template>
            <FormRegister />
          </b-tab>
          <b-tab>
            <template #title>
              <div class="d-flex align-items-center">2. Validación</div>
            </template>
            <FormValidation />
          </b-tab>
          <b-tab>
            <template #title>
              <div class="d-flex align-items-center">3. Seguimiento médico</div>
            </template>
            <FormMedicalFollowup />
          </b-tab>
          <b-tab>
            <template #title>
              <div class="d-flex align-items-center">4. Comite</div>
            </template>
            <FormCommittee />
          </b-tab>
          <b-tab>
            <template #title>
              <div class="d-flex align-items-center">5. Seguimiento estado de salud</div>
            </template>
            <FormHealthStatusMonitoring />
          </b-tab>
          <!-- <div class="mt-5 d-flex justify-content-between">
            <button
              class="button_primary"
              :disabled="tabIndex <= 0"
              @click.prevent="previous"
            >
              Anterior
            </button>
            <button
              class="button_primary"
              @click.prevent="next"
              :disabled="tabIndex == 4"
            >
              Siguiente
            </button>
          </div> -->
        </div>
      </b-tabs>
    </b-overlay>
  </div>
</template>

<script>
import FormRegister from './forms/FormRegister.vue';
import FormValidation from './forms/FormValidation.vue';
import FormMedicalFollowup from './forms/FormMedicalFollowup.vue';
import FormCommittee from './forms/FormCommittee.vue';
import FormHealthStatusMonitoring from './forms/FormHealthStatusMonitoring.vue';
export default {
  components: {
    FormRegister,
    FormValidation,
    FormMedicalFollowup,
    FormCommittee,
    FormHealthStatusMonitoring
  },
  props: {},
  data() {
    return {
      loading: false,
      tabIndex: 0,
    };
  },
  computed: {},
  methods: {
    previous() {
      const me = this;
      me.tabIndex = me.tabIndex - 1;
    },
    next() {
      const me = this;
      me.tabIndex = me.tabIndex + 1;
    },
  },
  async mounted() {},
};
</script>

<style lang="scss">
.tabs-section-form-salud-event div:first-child {
  text-align: left;
}
.tabs-section-form-salud-event .nav-tabs {
  background: white !important;
  padding: 4px !important;
  border-radius: 30px !important;
  align-items: center !important;
  border: 1px solid #c9caff !important;
  display: inline-flex !important;
  // width: 100% !important;
}

.tabs-section-form-salud-event .nav-tabs li {
  width: 100% !important;
}

.tabs-section-form-salud-event .nav-tabs .nav-item a {
  color: #546e7a !important;
  font-weight: 700 !important;
  margin-bottom: 0 !important;
}

.tabs-section-form-salud-event .nav-tabs .nav-item a {
  border: none !important;
}

.tabs-section-form-salud-event .nav-tabs .nav-item a.active {
  background-color: #5d5fef !important;
  color: white !important;
  padding: 8px 16px 8px 16px !important;
  border-radius: 30px !important;
  border-bottom: 0 !important;
}

.button_primary {
  display: flex;
  align-items: center;
  background-color: #5d5fef;
  height: 40px;
  border-radius: 8px;
  font-size: 18px;
  gap: 10px;
  border: none;
  color: white;
  padding: 15px;
}

.alert-danger-form-salud-event {
  border: 1px solid #ac0000 !important;
  border-radius: 4px !important;
  background-color: #ffdfdf !important;
  margin-bottom: 40px;
}
</style>
